<script>
import resources from './resources'
import '@desislavsd/vue-select/dist/vue-select.css'

export default {
  name: 'unit-form',
  mixins: [resources]
}
</script>

<template lang="pug">
section.content
  .container-fluid
    .block-header
      .row
        .col-lg-5.col-md-5.col-sm-12
          h2 Visitantes
          ul.breadcrumb.padding-0
            li.breadcrumb-item
              a(href="index.html")
                i.zmdi.zmdi-home
            li.breadcrumb-item
              a(href="javascript:void(0);") Visitantes
            li.breadcrumb-item.active Cadastro

    .row.clearfix
      .col-lg-12.col-md-12.col-sm-12
        .card
          .header
            h2
            ul.header-dropdown
              li
                router-link(:to="{ name: 'dweller.visitor.index' }")
                  i.zmdi.zmdi-format-list-bulleted
          .body
            .row.clearfix
              .col-lg-4.col-md-4
                .form-group
                  v-input(:status="$v.visitor.name.$error ? 'error' : null")
                    input.form-control(
                      type="text",
                      v-model="visitor.name",
                      placeholder="Nome"
                    )
              .col-lg-4.col-md-4
                .form-group
                  input.form-control(
                    type="text",
                    v-model="visitor.country_register",
                    placeholder="CFP/RG"
                  )
              .col-lg-4.col-md-4
                .form-group
                  input.form-control(
                    type="text",
                    v-model="visitor.company",
                    placeholder="Empresa"
                  )

              .col-lg-6.col-md-6
                .form-group
                  f-select#unit_id(
                    name="status",
                    track-by="id",
                    label-by="label",
                    v-model="visitor.status",
                    :options="optionStatus",
                    :searchable="true",
                    :multiple="false",
                    openDirection="bottom"
                  )
              .col-lg-6.col-md-6
                .form-group
                  f-select(
                    name="type",
                    v-model="visitor.type",
                    :searchable="true",
                    :multiple="false",
                    placeholder="Tipo",
                    :options="optionType",
                    label-by="label"
                  )
              .col-md-12
                button.btn.btn-raised.btn-primary.btn-round.waves-effect(
                  type="button",
                  @click.prevent="doSave()"
                ) Salvar
</template>
<style scoped>
.color-red {
  color: #f96332;
}
</style>



// WEBPACK FOOTER //
// src/app/dweller/visitor/form/form.vue